<template>
  <div class="ips">
    <div class="d-flex">
      <b-badge class="mx-auto" variant="info" @click="showIps">
        {{ ips[0].ip }}
      </b-badge>
    </div>
    <modal :name="`showIps-${id}`" :width="500" height="auto">
      <div class="container vld-parent py-5">
        <h1>Ips</h1>
        <div class="bg-danger" v-for="{ ip, id } in ips" :key="id">
          <b-alert show class="my-2">{{ ip }}</b-alert>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    ips: Array,
    id: String,
  },
  methods: {
    showIps() {
      this.$modal.show(`showIps-${this.id}`);
    },
  },
};
</script>
